import React, { useEffect, useState } from "react";
import { GoogleMap, Marker, InfoWindow } from "@react-google-maps/api";
import { useSelector } from "react-redux";
import { useGetCartDetailsByIdQuery } from "../../redux/services/cartSearchService";
import './index.css'
import { useGoogleMaps } from "../../hooks/useGoogleMaps";

const containerStyle = {
  width: "100%",
  height: "70vh",
};

const defaultCenter = {
  lat: 6.9270786,
  lng: 79.861243,
};

const CartMapView: React.FC = () => {
    const { isLoaded, loadError } = useGoogleMaps();


  const iconURL =
    "https://storage.googleapis.com/fooddelivery-7eac6.appspot.com/Icons/cart-icon.png";

  const cart = useSelector((state: any) => state?.cart?.selectedCart);
  const cartId = cart?.id || cart?.cartId;

  const {
    data: cartData,
    isLoading: isFetching,
    refetch,
  } = useGetCartDetailsByIdQuery(cartId);

  const [liveLocation, setLiveLocation] =
    useState<google.maps.LatLngLiteral | null>(null);
  const [showInfo, setShowInfo] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
 
  useEffect(() => {
    if (cartData?.liveLocation) {
      const { _latitude, _longitude } = cartData.liveLocation;
      setLiveLocation({
        lat: _latitude,
        lng: _longitude,
      });
    }
  }, [cartData]);

  const handleRefresh = async () => {
    setRefreshing(true);
    const result = await refetch();
    setRefreshing(false);
    if (result?.data?.liveLocation) {
      const { _latitude, _longitude } = result.data.liveLocation;
      setLiveLocation({
        lat: _latitude,
        lng: _longitude,
      });
    }
  };

  if (loadError) {
    return <div>Error loading Google Maps</div>;
  }

  if (!isLoaded) {
    return <div>Loading Maps...</div>;
  }

  return (
    <div style={{ position: "relative" }}>
      <button
        onClick={handleRefresh}
        disabled={refreshing || isFetching}
        className="refreshButton"
      >
        {refreshing ? "Refreshing..." : "Refresh Location"}
      </button>

      <GoogleMap
        mapContainerStyle={containerStyle}
        center={liveLocation || defaultCenter}
        zoom={15}
        options={{
          disableDefaultUI: false,
          clickableIcons: false,
          styles: [
            {
              featureType: "poi",
              stylers: [{ visibility: "off" }],
            },
          ],
        }}
      >
        {liveLocation && (
          <Marker
            position={liveLocation}
            icon={{
              url: iconURL,
              scaledSize: new window.google.maps.Size(40, 40),
            }}
            onMouseOver={() => setShowInfo(true)}
            onMouseOut={() => setShowInfo(false)}
          />
        )}

        {liveLocation && showInfo && cartData?.displayName && (
          <InfoWindow
            position={liveLocation}
            options={{ pixelOffset: new window.google.maps.Size(0, -40) }}
            onCloseClick={() => setShowInfo(false)}
          >
            <div style={{ padding: "10px", maxWidth: "250px" }}>
              <h5>{cartData.displayName}</h5>
            </div>
          </InfoWindow>
        )}
      </GoogleMap>
    </div>
  );
};

export default CartMapView;